export default __webpack_public_path__ + "static/charts-ru-f9e049ee565e09266bb3c0ce22e13130.png";